import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import defaultAvatar from '../../assets/unknown-user-icon.png';
import Anchor from '../Anchor/Anchor';

import './UserAvatar.css';

const UserAvatar = ({ avatar, userId, authorIsUser, isHyperlink }) => {
  const [imageError, setImageError] = useState(false);
  const [supportsObjectFit, setSupportsObjectFit] = useState(true);
  const handleImageError = () => {
    setImageError(true);
  };
  useEffect(() => {
    if ('objectFit' in document.documentElement.style === false) {
      setSupportsObjectFit(false);
    }
  }, []);

  const cleanAvatar = (avatarUrl) => {
    // eslint-disable-next-line no-restricted-globals
    const pageProtocol = location.protocol;
    const protocols = ['http:', 'https:'];
    const urlProtocol = protocols.find((protocol) => {
      return avatarUrl.indexOf(protocol) === 0;
    });

    if (typeof urlProtocol === 'undefined' || pageProtocol === urlProtocol) {
      return avatarUrl;
    }
    // luckily for us string.replace with a string literal as the first argument only replaces first match - boom!
    return avatarUrl.replace(urlProtocol, pageProtocol);
  };

  const profileUrl = authorIsUser
    ? '/profile/my#contents'
    : `/users/${userId}#contents`;

  const renderAvatar = () => {
    if (!supportsObjectFit) {
      return (
        <span
          styleName="background-avatar"
          style={{ backgroundImage: `url(${cleanAvatar(avatar)})` }}
        >
          {isHyperlink && <Anchor href={profileUrl} newTab={false} />}
        </span>
      );
    }

    return (
      <>
        {isHyperlink ? (
          <Anchor href={profileUrl} newTab={false}>
            <img
              styleName="avatar"
              src={cleanAvatar(avatar)}
              alt="avatar"
              onError={handleImageError}
            />
          </Anchor>
        ) : (
          <img
            styleName="avatar"
            src={cleanAvatar(avatar)}
            alt="avatar"
            onError={handleImageError}
          />
        )}
      </>
    );
  };

  return (
    <div styleName="container">
      {avatar && imageError === false ? (
        renderAvatar()
      ) : (
        <img
          styleName="default-avatar"
          src={defaultAvatar}
          alt="default avatar"
        />
      )}
    </div>
  );
};

UserAvatar.propTypes = {
  userId: PropTypes.number,
  avatar: PropTypes.string,
  authorIsUser: PropTypes.bool,
  isHyperlink: PropTypes.bool
};

UserAvatar.defaultProps = {
  userId: null,
  avatar: defaultAvatar,
  isHyperlink: true,
  authorIsUser: false
};

export default UserAvatar;
